import { Base } from './base.model';
import { StripeAccount } from './stripe-account.model';

import { RoleEnum } from '../constants/role.enums';
import { Type } from '../decorators/type.decorator';
import { UserRoleType } from "./user-role-type.model";

export class User extends Base {
  public fullAddress: string;
  public city: string;
  public cognitoSubject: string;
  public createdAt: Date;
  public dateOfBirth: Date;
  @Type(User) public delegate: User;
  @Type(User) public landowners: User[];
  public delegateId: number;
  public email: string;
  public firstName: string;
  public company: string;
  public title: string;
  public identifier: string;
  public isActive: boolean;
  public isVerified: boolean;
  public landownerId: number;
  public lastLogin: Date;
  public lastName: string;
  public mfaEnabled: boolean;
  public smsOptIn: boolean;
  public needsIdVerification: boolean;
  public phone: string;
  public phoneE164: string;
  @Type(User) public rejectedBy: User;
  @Type(UserRoleType) public role: UserRoleType;
  public state: string;
  public street1: string;
  public street2: string;
  @Type(StripeAccount) public stripeAccounts: StripeAccount[];
  public identityAttempts: number;
  public identityProviderId: string;
  @Type(User) public verifiedBy: User;
  public zip: string;
  public flaggedProfile: boolean;
  public initialData: any;
  public verifiedStatus: string;
  public userSiteStatus: string;

  getDisplayName({ reverse = false, initials = false, includeEmail = false } = {}) {
    if (this.email) {
      if (initials) {
        if (this.firstName == null) {
          return this.email.substring(0, 2).toUpperCase();
        } else if (this.lastName == null) {
          return this.firstName.substring(0, 2).toUpperCase();
        } else {
          return `${this.firstName.charAt(0)}${this.lastName.charAt(0)}`;
        }
      }
      let name: string;
      if (this.firstName == null) {
        name = '--';
      } else if (this.lastName == null) {
        name = this.firstName;
      } else {
        name = reverse ? `${this.lastName}, ${this.firstName}` : `${this.firstName} ${this.lastName}`;
      }
      return includeEmail ? `${name} <${this.email}>` : name;
    }
    return '';
  }

  hasStripe(): boolean {
    return this.stripeAccounts?.filter(sa => sa.stripeAccountCreationDate != null).length > 0;
  }

  get isReadOnlyAdmin() {
    return [RoleEnum.ReadAdmin.toString(), RoleEnum.FinanceAdmin.toString()].includes(this.role.name);
  }

  get isWriteAdmin() {
    return [RoleEnum.Admin.toString(), RoleEnum.SuperAdmin.toString()].includes(this.role.name);
  }

  get isSuperAdmin(): boolean {
    return this.role.name === RoleEnum.SuperAdmin;
  }

  get isLandowner(): boolean {
    return this.role.name === RoleEnum.Landowner;
  }

  get canPaySites() {
    return [RoleEnum.FinanceAdmin.toString(), RoleEnum.SuperAdmin.toString()].includes(this.role.name);
  }

  get isManuallyVerified(): boolean {
    return this.isVerified && this.verifiedBy !== null;
  }

  get isSystemVerified(): boolean {
    return this.isVerified && this.identityProviderId && this.verifiedBy == null;
  }
}
